/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Dropdown } from 'react-bootstrap';
import Axios from 'axios';

// project imports
import store from 'features/store';

// style imports
import './Header.scss';
import { getSellerHeaders, getSellerUrl } from 'shared/http';
import { contentText } from 'shared/settings/apiconfig';

/**
 * defines header once login is made
 * 
 * @param props
 * 
 * @returns html code for rendering header after login
 * 
**/

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bannerText: ""
        };
    }
    componentDidMount() {
        // this.getRequiredData();
    }

    getRequiredData = () => {
        Axios.get(getSellerUrl(`${contentText}SELLER_BANNERTEXT`), getSellerHeaders(null, false)).then(res => {
            const data = res.data.data[0];
            this.setState({
                bannerText: data ? data["description"] : ""
            });
        }).catch(error => error);
    }

    onLogoutUser = () => {
        store.dispatch({ type: 'TOGGLE_LOGOUT_MODAL', payload: true });
    };

    onSidebarToggle = () => {
        store.dispatch({ type: 'TOGGLE_SIDEBAR', payload: true });
    };

    render() {

        return (
            <div className="d-flex flex-row header-box border-bottom border-outline">
                <div className="d-none d-lg-flex flex-row logo-box">
                    <div className="d-flex flex-row align-items-center logo">
                        <a href="/" className="logo-link">
                            <img src={`${process.env.PUBLIC_URL}/static/logo/Admin_logo.png`} alt="logo" height="52px" width="180px" />
                        </a>
                    </div>
                </div>
                <div className="d-flex flex-row align-items-center justify-content-end w-100">
                    {
                        this.props.sidebar ?
                            <div className="d-flex d-lg-none flex-row align-items-center justify-content-center sidebar-toggle" onClick={this.onSidebarToggle}>
                                <i className="fa fa-bars"></i>
                            </div> :
                            null
                    }

                    <div className="d-flex flex-row align-items-center justify-content-end tool-box">

                        {/* Just remove this div for remove downtime warning */}
                        {
                            this.state.bannerText ?
                                <div style={{ flex: '1 1 auto' }}>
                                    <div className="downtime-warning">
                                        <div className="warning-content d-flex align-items-center justify-content-center">
                                            <div dangerouslySetInnerHTML={{ __html: this.state.bannerText }} className="p-tag-margin ql-editor"></div>
                                        </div>
                                    </div>
                                </div> : null
                        }

                        <div className="d-none d-lg-flex user-details">
                            <div className="user-name">
                                <span style={{ fontSize: '13px' }}>{`${this.props['user']['lastName'] ? this.props['user']['lastName'] + ', ' : ''}${this.props['user']['firstName'] ? this.props['user']['firstName'] : ''}`}</span>
                            </div>
                        </div>
                        <div className="d-none d-lg-flex profile-border-outer">
                            <Link to="/profile">
                                {
                                    this.props['user']['profileImage'] ?
                                        <img src={this.props['user']['profileImage']} alt="profile" height="28" width="28" /> :
                                        <img src={process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg'} alt="profile" height="28" width="26" className="profile" />
                                }
                            </Link>
                        </div>
                        <Button variant="dark" className="d-none d-lg-flex logout-button" onClick={this.onLogoutUser}>
                            <img src="/static/icons/header/logout.svg" alt="logout" height="18px" width="18px" className="logout-button-icon" />
                            <span className="logout-button-name">Sign Out</span>
                        </Button>
                        <Dropdown className="quick-link" alignRight>
                            <Dropdown.Toggle id="quickLinks" className="bg-white border-0">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/header/menu.svg`} alt="menu" height="25px" width="25px" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="shadow">
                                <Dropdown.Item as={Link} to="/profile" style={{ textDecoration: 'none' }}>
                                    <div className="d-flex flex-row" style={{ margin: '10px' }}>
                                        <div className="menu-item-profile">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/profile/default_1.svg`} alt="profile" height="15px" width="15px" />
                                        </div>
                                        <span className="pt-1">My Profile</span>
                                    </div>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item as={Link} to="/change-password" style={{ textDecoration: 'none' }}>
                                    <div className="d-flex flex-row" style={{ margin: '10px' }}>
                                        <div className="menu-item-password">
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/quick-links/padlock.svg`} alt="profile" />
                                        </div>
                                        <span>Change Password</span>
                                    </div>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => state)(Header);
